<template>
  <v-autocomplete
    ref="auditor"
    :label="title"
    v-model="selected"
    :items="items"
    :item-text="nombreCompleto"
    item-value="uuid"
    :rules="rules"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
    return-object
    @change="$emit('input', selected)"
  ></v-autocomplete>
</template>

<script>
import format from '~/util/formatHelper'

export default {
  name: 'SelectAuditoresObject',
  props: {
    value: Object,
    title: { type: String, default: 'Auditor' },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideDetails: { type: String, default: 'auto' },
    filtAlcanceUuid: { type: String, default: null },
    filtAuditorTipo: { type: String, default: null },
  },
  mounted() {
    if (this.required) {
      this.rules = [(v) => !!v || 'Obligatorio']
    }
    this.getItems()
  },
  data(ctx) {
    return {
      rules: [],
      selected: ctx.value,
      items: [],
    }
  },
  computed:{
    isCCL() {
      return this.$auth.user.empresa.nombre == 'Ccl'
    },
    isRevision() {
      return this.$route.path.includes('revisiones')
    },
    isDictamen() {
      return this.$route.path.includes('dictamenes')
    },
  },
  methods: {
    nombreCompleto(item) {
      return format.fullName(item.contacto)
    },
    async getItems() {
      const res = await this.$store.dispatch('auditores/list')
      if (!res) return

      const hoy = new Date().toISOString().substr(0, 10)
      const formatDate = (d) => new Date(d).toISOString().slice(0, 10)
      this.items = res.filter((auditor) => {
        if (!auditor.user?.activo) return false

        if (this.isCCL) {
          console.log('si es CCL')
          if (this.filtAlcanceUuid || this.filtAuditorTipo) {
            return auditor.afinidades.some((af) => {
              const alcanceUuid = af.alcance
              const nivel = af.nivel
              const desde = af.desde || '0000-01-01'
              const hasta = af.hasta || '9999-12-31'
              const desdeStr = formatDate(desde)
              const hastaStr = formatDate(hasta)
              const matchesAlcance = this.filtAlcanceUuid ? alcanceUuid === this.filtAlcanceUuid : true
              const matchesTipo = this.filtAuditorTipo ? nivel === this.filtAuditorTipo : true
              const isActive = hoy >= desdeStr && hoy <= hastaStr
              /*console.log('--- Afinidad Evaluada ---')
              console.log('Auditor:', format.fullName(auditor.contacto))
              console.log('Alcance UUID:', alcanceUuid)
              console.log('Nivel:', nivel)
              console.log('Desde:', desdeStr)
              console.log('Hasta:', hastaStr)
              console.log('Fecha hoy:', hoy)
              console.log('matchesAlcance:', matchesAlcance)
              console.log('matchesTipo:', matchesTipo)
              console.log('isActive:', isActive)*/
              return matchesAlcance && matchesTipo && isActive
            })
          }
        }
        return true
      })
    },
  },
  watch: {
    value: function (val) {
      if (!val || val === undefined) this.$refs.auditor.reset()
      this.selected = val
    },
    filtAlcanceUuid() {
      this.getItems()
    },
    filtAuditorTipo() {
      this.getItems()
    },
  },
}
</script>
